/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-03-03 16:28:36
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-23 14:51:18
 * @FilePath: \合联\oms\src\api\system\city.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取批量信息
export const getCity = params => {
  return axios.request({
    url: "/common/city",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/common/city/${id}`,
    method: "GET"
  });
};
// 删除单个信息
export const del = id => {
  return axios.request({
    url: `/common/city/${id}`,
    method: "DELETE"
  });
};
// 修改单个信息
export const update = data => {
  return axios.request({
    url: `/common/city/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增单个信息
export const add = data => {
  return axios.request({
    url: "/common/city",
    method: "POST",
    data
  });
};

// 新增单个信息
export const getFinaDivision = params => {
  return axios.request({
    url: "/common/financialDivision",
    method: "get",
    params
  });
};

export const sync = data => {
  return axios.request({
    url: "/common/city/sync",
    method: "POST",
    data
  });
};

export const setRegions = data => {
  return axios.request({
    url: "/common/city/setRegions",
    method: "POST",
    data
  });
};

export const setRemoteDepth = data => {
  return axios.request({
    url: "/common/city/setRemoteDepth",
    method: "POST",
    data
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/common/city/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const setTemuPartition = data => {
  return axios.request({
    url: "/common/city/setTemuPartition",
    method: "POST",
    data
  });
};

export const ageing = data => {
  return axios.request({
    url: "/common/city/ageing",
    method: "POST",
    data
  });
};